import { getProjectId } from '../../../utils/dataNormalization';

const isTruthyFlag = (value) => (
  value === true ||
  value === 1 ||
  value === '1' ||
  (typeof value === 'string' && ['true', 'yes', 'y'].includes(value.trim().toLowerCase()))
);

export const isInternationalShippingJob = (job, soldToShipToByProject = {}) => {
  if (!job) {
    return false;
  }

  if (isTruthyFlag(job.InternationalShip)) {
    return true;
  }

  if (Array.isArray(job.SoldToShipTo)) {
    return job.SoldToShipTo.some((item) => isTruthyFlag(item?.InternationalShip));
  }

  const projectId = getProjectId(job);
  if (!projectId) {
    return false;
  }

  const soldToShipToData = soldToShipToByProject[projectId]?.data;
  return isTruthyFlag(soldToShipToData?.InternationalShip);
};
